import * as React from 'react';
import { useQuery } from 'react-query';
import { DigitalStylingOrderCustomerInProgress } from './DigitalStylingOrderCustomerInProgress';
import { DigitalStylingOrderView, DigitalStylingOrderViewLabels } from './DigitalStylingOrderView';
import {
    CustomerDigitalStylingApi,
    CustomerDigitalStylingResponse
} from '../queries/CustomerDigitalStylingApi';
import { DigitalStylingStatus } from '../../shared/types';
import { DigitalStylingOrderViewSkeleton } from './DigitalStylingOrderViewSkeleton';
import { downloadZip } from '../../shared/state/downloadUtils';
import Skeleton from '@mui/material/Skeleton';

export type DigitalStylingOrderCustomerViewLabels = {
    orderInProgress: string;
} & DigitalStylingOrderViewLabels;

type DigitalStylingOrderCustomerViewProps = {
    orderId: number;
    labels: DigitalStylingOrderCustomerViewLabels;
};

export function DigitalStylingOrderCustomerView({
    orderId,
    labels
}: DigitalStylingOrderCustomerViewProps) {
    let queryKey = 'customerDigitalStylingOrder';
    let { data, isError, isLoading, error } = useQuery<CustomerDigitalStylingResponse>(
        [queryKey],
        () => CustomerDigitalStylingApi.getData(orderId)
    );

    function handleDownloadHighResolutionImages() {
        function downloadFunc() {
            return CustomerDigitalStylingApi.downloadHighResolutionImages(orderId);
        }

        return downloadZip(downloadFunc);
    }

    function handleDownloadNormalResolutionImages() {
        function downloadFunc() {
            return CustomerDigitalStylingApi.downloadNormalResolutionImages(orderId);
        }

        return downloadZip(downloadFunc);
    }

    if (isError) {
        console.error('Error loading customer digital styling order data', error);
    }

    if (isLoading) {
        return (
            <fieldset>
                <Skeleton
                    variant="text"
                    sx={{ fontSize: '1.4rem', padding: '20px 20px 10px 20px' }}
                />
            </fieldset>
        );
    }

    let { orderStatus, images, hasNormalResolutionImagesAvailable } = data
        ? data
        : { orderStatus: null, images: [], hasNormalResolutionImagesAvailable: false };

    if (orderStatus !== null && orderStatus.value >= DigitalStylingStatus.Delivered) {
        return (
            <DigitalStylingOrderView
                images={images}
                labels={labels}
                hasNormalResolutionImagesAvailable={hasNormalResolutionImagesAvailable}
                onDownloadHighResolutionImages={handleDownloadHighResolutionImages}
                onDownloadNormalResolutionImages={handleDownloadNormalResolutionImages}
            />
        );
    }

    return <DigitalStylingOrderCustomerInProgress text={labels.orderInProgress} />;
}
